import React from "react";

interface CloseIconProps {
  size?: "default" | "small" | "xs" ;
}

const SelectedIcon: React.FC<CloseIconProps> = ({ size = "default" }) => {
  let left = "36px";
  if (size === "small") {
    left = "30px";
  } else if (size === "default") {
    left = "36px";
  } else if (size === "xs") {
    left = "22px";
  }
  return (
    <div
      style={{
        width: "8px",
        height: "8px",
        background: "#000",
        padding: "2px",
        borderRadius: "50%",
        position: "absolute",
        top: "-2px",
        left: left,
      }}
    >
      <svg
        style={{
          display: "block",
        }}
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4472_425)">
          <path
            d="M1 3.83341L3.3337 6.00008L7 1.66675"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4472_425">
            <rect width="8" height="8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default SelectedIcon;
